import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { encounterReadLoading } from '@enlyt/stores/Fhir/Select'

import ResultItem from '../../BaseInfoCard/ResuleItem'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import localization from '../../localization'
import _ from 'lodash'

import TestResultSvg from '@images/custom/icons/eh-icon-test-results-gray.svg'
import withLocalization from '@web/helpers/localizationUtils'

/* eslint-disable react-hooks/exhaustive-deps */

const TestResultItem = ({ test, isLast, t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const testInfo = useMemo(() => Object.values(test), [test])
  const testDates = useMemo(() => Object.keys(test), [test])
  const encounterId = useMemo(
    () => _.get(testInfo, '[0][0].encounterId', 0),
    [test]
  )
  const isLoading = useSelector(encounterReadLoading(encounterId))

  const testName = useMemo(() => {
    return _.get(testInfo, '[0].code') || t('noData')
  }, [test])

  const lastTestDate = useMemo(() => {
    return testDates[0]
  }, [test])

  const value = useMemo(() => {
    const value = _.get(testInfo, '[0].result', '')
    const units = _.get(testInfo, '[0].units', '')
    return `${t('value')}: ${value} ${units}`
  }, [testInfo])

  const isEmptyRange = value => _.isNil(value) || value === ''
  const range = useMemo(() => {
    if (_.get(testInfo, '[0].textRange', '')) {
      return `${t('normalRange')}: ${_.get(testInfo, '[0].textRange')}`
    }
    if (
      _.get(testInfo, '[0].range', '') &&
      !isEmptyRange(_.get(testInfo, '[0].low', '')) &&
      !isEmptyRange(_.get(testInfo, '[0].high', ''))
    ) {
      return `${t('normalRange')}: ${_.get(testInfo, '[0].range')}`
    }
    return null
  }, [testInfo])

  return (
    <ResultItem
      style={styles}
      loading={isLoading}
      isLast={isLast}
      iconGray={<TestResultSvg />}
      iconSize={32}
      title={testName}
      value={value}
      subTitle={range}
      date={lastTestDate}
      loadingText={t('loading')}
    />
  )
}

export default withLocalization(TestResultItem, localization)
